module.exports = __webpack_public_path__ + "media/images/80sTeesWOutline_2-be80a6f110e532f5ccffd4c2d4c8ac12.svg";